import { ref, watch } from "vue";
import { chatState, setCurrentRoomId } from "./chatState";
import { debounce } from "lodash-es";

export function useIframeHandler() {
  const isLoading = ref(true);
  const url = process.env.VUE_APP_CHAT_DOMAIN || "";
  const loginAttempts = ref(0);
  const isLoginAttempted = ref(false);

  const updateIframeSrc = () => {
    const iframe = document.getElementById("rcChannel") as HTMLIFrameElement;

    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(
        {
          externalCommand: "go",
          path: getUrl(),
        },
        process.env.NODE_ENV === "development" ? "*" : url
      );
    }
  };

  const updateChatRoom = (newRoomId: string) => {
    setCurrentRoomId(newRoomId);
  };

  const attemptLogin = () => {
    const iframe = document.getElementById("rcChannel") as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(
        {
          externalCommand: "login-with-token",
          token: chatState.token,
        },
        process.env.NODE_ENV === "development" ? "*" : url
      );
    }
  };
  const getUrl = () => {
    const type = chatState.type;
    const roomId = chatState.currentRoomId;
    switch (type) {
      case "customerService":
        return `/group/${roomId}?lang=zh-CN`;
      case "user":
        return `/direct/${roomId}?lang=zh-CN`;
      case "home":
      default:
        return `/home`;
    }
  };
  // 防抖更新 iframe src，避免频繁更新
  const debouncedUpdate = debounce(() => {
    updateIframeSrc();
  }, 100); // 100ms 延迟

  watch(
    [
      () => chatState.currentRoomId,
      () => chatState.type,
      () => chatState.clickType,
    ],
    () => {
      debouncedUpdate();
    }
  );

  return {
    isLoading,
    updateChatRoom,
    attemptLogin,
    loginAttempts,
    isLoginAttempted,
  };
}
